/**
 * Color Variants Collection
 * Handles show more/less functionality for color variant rows
 */

class ColorVariantsCollection extends HTMLElement {
  constructor() {
    super();

    this.rowsToShow = parseInt(this.dataset.rowsToShow, 10) || 2;
    this.mobileVisibleLimit = parseInt(this.dataset.mobileVisibleLimit, 10) || 5;
    this.variantsList = this.querySelector('.color-variants-list');
    this.viewMoreBtn = this.querySelector('[data-view-more]');
    this.viewAllColorsBtn = this.querySelector('[data-view-all-colors]');
    this.isInitialized = false;
    this.mobileMediaQuery = window.matchMedia('(max-width: 999px)');
    this.onMediaChange = this.handleMediaChange.bind(this);

    if (this.rowsToShow === 0 || !this.variantsList) return;
  }

  connectedCallback() {
    const images = this.querySelectorAll('img');

    this.mobileMediaQuery.addEventListener('change', this.onMediaChange);

    if (images.length === 0) {
      this.init();
    } else {
      const firstImage = images[0];

      if (firstImage.complete) {
        this.init();
      } else {
        firstImage.addEventListener('load', () => {
          if (!this.isInitialized) {
            this.init();
          }
        });
      }

      setTimeout(() => {
        if (!this.isInitialized) {
          this.init();
        }
      }, 300);
    }
  }

  disconnectedCallback() {
    this.mobileMediaQuery.removeEventListener('change', this.onMediaChange);
  }

  init() {
    if (this.isInitialized) return;
    this.isInitialized = true;

    if (this.viewAllColorsBtn) {
      this.viewAllColorsBtn.addEventListener('click', () => {
        this.dataset.colorsExpanded = 'true';
        this.viewAllColorsBtn.setAttribute('aria-expanded', 'true');
      });
    }

    this.applyMobileState();
  }

  handleMediaChange() {
    this.applyMobileState();
  }

  applyMobileState() {
    const optionsCount = parseInt(this.dataset.colorOptionsCount || '0', 10);
    const hasOverflow = optionsCount > this.mobileVisibleLimit;

    if (!this.mobileMediaQuery.matches || !hasOverflow) {
      this.dataset.colorsExpanded = 'true';
      if (this.viewAllColorsBtn) {
        this.viewAllColorsBtn.setAttribute('aria-expanded', 'true');
      }
      return;
    }

    const hasSelectedInHidden = Boolean(
      this.querySelector('.color-variants-list__cell[data-trimmed="true"] .is-selected')
    );

    if (hasSelectedInHidden) {
      this.dataset.colorsExpanded = 'true';
      if (this.viewAllColorsBtn) {
        this.viewAllColorsBtn.setAttribute('aria-expanded', 'true');
      }
    } else {
      this.dataset.colorsExpanded = 'false';
      if (this.viewAllColorsBtn) {
        this.viewAllColorsBtn.setAttribute('aria-expanded', 'false');
      }
    }
  }
}

if (!customElements.get('color-variants-collection')) {
  customElements.define('color-variants-collection', ColorVariantsCollection);
}
